import React, { FC } from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { DragObjectWithType, useDrop } from 'react-dnd';

import itemsType from '~Scenes/Tables/Components/dragItemsType';
import DeleteIcon from '~/Assets/icons/delete_outline.svg';
import Icon from '~ComponentsImproved/Icon';

const overStyles = css`
  & > * {
    border-color: #ffc000;
  }
`;

const DropWrapper = styled.div<{
  isOver: boolean;
  canDrop: boolean;
}>`
  width: 64px;
  height: 60px;
  box-sizing: border-box;
  ${({ isOver }) => isOver && overStyles}
`;

const DeleteBox = styled.div`
  height: 100%;
  width: 100%;
  border-radius: 4px;
  border: 1px dashed var(--colorBlueGray800);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export type DraggedCheque = {
  id: string;
  type: 'cheque';
};
interface Props {
  onDrop: (data: DraggedCheque) => void;
}

const DeleteChequeTarget: FC<Props> = ({ onDrop }) => {
  const [{ isOver, canDrop }, drop] = useDrop({
    accept: [itemsType.CHEQUE],
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
    drop: (data: DraggedCheque) => {
      onDrop(data);
    },
  });

  return (
    <DropWrapper ref={drop} canDrop={canDrop} isOver={isOver}>
      <DeleteBox>
        <Icon src={DeleteIcon} color="var(--colorBlueGray50)" />
      </DeleteBox>
    </DropWrapper>
  );
};

export default DeleteChequeTarget;
